import React from 'react';
import "./testimonials.css";
import { Data } from "./Data";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/pagination";
import "swiper/css/autoplay";
import { Pagination, Autoplay } from 'swiper';

const Testimonials = () => {
  return (
    <section className="testimonial container section">
        <h2 className="section__title">آراء المتابعين</h2>
        <span className="section__subtitle"></span>

        <Swiper
            className="testimonial__container"
            loop={true}
            grabCursor={true}
            spaceBetween={24}
            autoplay={{
                delay: 2500,
                disableOnInteraction: false,
            }}
            pagination={{ clickable: true }}
            breakpoints={{
                576: {
                    slidesPerView: 1,
                    spaceBetween: 48,
                },
                768: {
                    slidesPerView: 2,
                    spaceBetween: 48,
                },
            }}
            modules={[Pagination, Autoplay]}
        >
            {Data.map(({id, image, title, description}) => (
                <SwiperSlide className="testimonial__card" key={id}>
                    <img src={image} alt="client" className="testimonial__img" />
                    <h3 className="testimonial__name">{title}</h3>
                    <p className="testimonial__description">{description}</p>
                </SwiperSlide>
            ))}
        </Swiper>    
    </section>
  );
}

export default Testimonials;
